module.exports = __webpack_public_path__ + "static/media/img-2.d8232bc1.jpg";